<script setup lang="ts">
import { useCommonCodeStore } from '~/store/commonCodeStore';


const commonCodeStore = useCommonCodeStore();

const props = defineProps<{
  eqStatus: string;
}>()

</script>

<template>
  <div class="simple-equip-status">
    <div class="eqStatus eqStatus-on" v-if="props.eqStatus === 'on'">
      켜짐
    </div>
    <div class="eqStatus eqStatus-off" v-else-if="props.eqStatus === 'off'">
      꺼짐
    </div>
    <div v-else :class="`eqStatus eqStatus-${props.eqStatus}`">
      {{ commonCodeStore.getMapCode('opStatus', props.eqStatus)?.codeName }}
    </div>
  </div>  
</template>

<style lang="scss" scoped>
.simple-equip-status{
  color: var(--Neutral-Colors-100, #FFF);
  leading-trim: both;
  text-edge: cap;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: "Noto Sans";
  font-size: 0.7vw;
  font-style: normal;
  font-weight: 600;
  line-height: 22px; /* 137.5% */
  text-align: center;
  .eqStatus{
    border-radius: 20px;
    padding: 5px 0px;
  }
}
.eqStatus-normal{
  background-color: #27ae60;
}
.eqStatus-preparing{
  background-color: #0084ff;
}
.eqStatus-warning{
  background-color: #F28F51;
}
.eqStatus-fault{
  background-color: #C43232;
}
.eqStatus-down{
  background-color: #a9a9a9;
}
.eqStatus-on{
  background-color: #27ae60;
}
.eqStatus-off{
  background-color: #a9a9a9;
}
</style>